import {
	BackdropCircularProgress,
	EnhancedSnackbar,
} from "@websential/cosmic-v20";
import { BasicPaymentRecordHeaderColumns, HeaderRecordHeaderColumns, TrailerRecordHeaderColumns } from "./VaidationParserHeaderColumns";
import {
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../../common/constants";
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { BasicPaymentRecordParserDataGrid } from "./panels/BasicPaymentRecordParserDataGrid";
import { Grid } from "@mui/material";
import { HeaderRecordParserDataGrid } from "./panels/HeaderRecordParserDataGrid";
import { IAppState } from "../../../../store/reducers";
import { IGetListRequest } from "../../../../models";
import { TrailerRecordParserDataGrid } from "./panels/TrailerRecordParserDataGrid";
import { TransactionsServices } from "../../../../services/DirectDeposit/TransactionsServices";

import { setSelectedDrawerOptionsMenu } from "../../../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../../../store/actions";
import { useNavigateToLogout } from "../../../../common/Common";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

export interface ICollectionUploadedParserSetup { }
const COLLECTION_UPLOADED_TRANSACTIONS_PARSER_QUERY_KEY = "collection-uploaded-transaction-parser-list";

const useCollectionUploadedTransactionsParser = (
	id: string | undefined,
	params: IGetListRequest,
	navigateToLogout: (path: any) => void
) =>
	useQuery({
		queryKey: [
			COLLECTION_UPLOADED_TRANSACTIONS_PARSER_QUERY_KEY,
			id,
			params,
		],
		queryFn: () =>
			TransactionsServices.getCollectionUploadedTransacitonsParserList(
				id,
				params,
				navigateToLogout
			),
		refetchOnWindowFocus: false,
	});

export const CollectionUploadedParser: React.FC<ICollectionUploadedParserSetup> = () => {
	const dispatch = useDispatch();
	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const navigateToLogout = useNavigateToLogout();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const { id } = useParams();

	const [editRecordId, setEditRecordId] = useState(id);
	const [collectionUploadedParserData, setCollectionUploadedParserData] = useState<any>(undefined);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "name",
		order_direction: "asc",
		page: 1,
		size: 25,
	});

	const onRequestParamsChange = useCallback((requestParams: any) => {
		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by:
				requestParams.sortField !== null
					? requestParams.sortField
					: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const { isPending, data } = useCollectionUploadedTransactionsParser(
		editRecordId,
		queryParams,
		navigateToLogout
	);
	const CollectionUploadedParserList: any | null = data;

	useEffect(() => {
		if (CollectionUploadedParserList) {
			setCollectionUploadedParserData(CollectionUploadedParserList);
		}
	}, [CollectionUploadedParserList]);

	const onSnackbarClosed = (
		_event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};


	const expandedLabels = ["Transactions", "Collection"];
	const expandedCollectionUploadedParserOrSetupItem = "Collection Uploaded";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Collection" &&
				item.label === expandedCollectionUploadedParserOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedCollectionUploadedParserOrSetupItem && "/direct-deposit/transactions/collection-uploaded",
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);



	return (
		<>
			<div
				style={{
					margin: "15px 0",
					fontSize: "1.5rem",
					fontWeight: "bold",
					fontFamily: "'Roboto','Helvetica','Arial',sans-serif",

				}}
			>
				{"Validation Parser"}
			</div>
			<BackdropCircularProgress
				open={isPending}
				testId="validation-parser"
			/>
			<HeaderRecordParserDataGrid

				columns={HeaderRecordHeaderColumns}
				rows={
					collectionUploadedParserData && collectionUploadedParserData.header
						? collectionUploadedParserData.header
						: []
				}
				showIndexColumn={false}
				showChecboxColumn={false}
				showSettingColumn={false}
				onSnackbarMessageData={(value: any) => setSnackbarData(value)}
				totalRecords={
					collectionUploadedParserData && collectionUploadedParserData.total
						? collectionUploadedParserData.total
						: 0
				}
				initialPageSize={INITIAL_PAGE_SIZE}
				rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
				onRequestParamsChange={onRequestParamsChange}
				searchFieldPlaceholder={"Search..."}
				pageTitle={"Header Record"}
			/>

			<BasicPaymentRecordParserDataGrid
				columns={BasicPaymentRecordHeaderColumns}
				rows={
					collectionUploadedParserData && collectionUploadedParserData.paymentRecord
						? collectionUploadedParserData.paymentRecord
						: []
				}
				showIndexColumn={false}
				showChecboxColumn={false}
				pageTitle={"Basic Payment Record"}
				showRowExpandedView={true}
			/>

			<TrailerRecordParserDataGrid
				columns={TrailerRecordHeaderColumns}
				rows={
					collectionUploadedParserData && collectionUploadedParserData.trailer
						? collectionUploadedParserData.trailer
						: []
				}
				showIndexColumn={false}
				showChecboxColumn={false}
				showSettingColumn={false}
				onSnackbarMessageData={(value: any) => setSnackbarData(value)}
				totalRecords={
					collectionUploadedParserData && collectionUploadedParserData.total
						? collectionUploadedParserData.total
						: 0
				}
				initialPageSize={INITIAL_PAGE_SIZE}
				rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
				onRequestParamsChange={onRequestParamsChange}
				searchFieldPlaceholder={"Search..."}
				pageTitle={"Trailer Record"}
			/>

			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"validation-parser"}
				open={snackbarData.open}
			/>
		</>
	);
};
